
export class VinValidateRequest {
	
	country: string;
	vin: string;
	language: string;
	application: string;
}
